export const EDIT_HELP_SETTINGS_POPUP = 'editHelpSettingsPopup';
export const ADD_HELP_SETTINGS_POPUP = 'addHelpSettingsPopup';

export const ALL_CLIENTS = 'ALL' as const;
